// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2Ao1m","form":"styles_form__2vi87"};